export default __webpack_public_path__ + "static/media/a4.afe0da69.JPG";